// Shared helpers for supply expiration display.

// Returns the number of days from today until the given expiration date.
// Negative = expired. Null/undefined date returns null.
export function daysUntilExpiration(expDate) {
  if (!expDate) return null;
  const exp = new Date(expDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  exp.setHours(0, 0, 0, 0);
  return Math.round((exp - today) / 86400000);
}

// Returns a status string for the expiration: 'expired' | 'critical' | 'warning' | 'ok' | 'none'
// critical = 0-7 days, warning = 8-30 days
export function expirationStatus(expDate) {
  const d = daysUntilExpiration(expDate);
  if (d === null) return 'none';
  if (d < 0) return 'expired';
  if (d <= 7) return 'critical';
  if (d <= 30) return 'warning';
  return 'ok';
}

// Inline style for an expiration badge based on status. Uses semantic
// tokens so it themes correctly in dark mode.
export function expirationStyle(status) {
  switch (status) {
    case 'expired':  return { color: 'var(--red)',   fontWeight: 700 };
    case 'critical': return { color: 'var(--red)',   fontWeight: 600 };
    case 'warning':  return { color: 'var(--amber)', fontWeight: 600 };
    case 'ok':       return { color: 'var(--text-primary)' };
    default:         return { color: 'var(--text-secondary)' };
  }
}

// Human-friendly label like "Expired 5 days ago" or "Expires in 12 days"
export function expirationLabel(expDate) {
  const d = daysUntilExpiration(expDate);
  if (d === null) return '—';
  if (d < 0) return `Expired ${Math.abs(d)} day${Math.abs(d) === 1 ? '' : 's'} ago`;
  if (d === 0) return 'Expires today';
  return `Expires in ${d} day${d === 1 ? '' : 's'}`;
}
